import React from 'react';
import { ReportFiltersLogic } from './ReportFiltersLogic';
import ReportFiltersUI from './ReportFiltersUI';

const ReportFilters = ({ onApplyFilters }) => {
  return (
    <ReportFiltersLogic onApplyFilters={onApplyFilters}>
      {({ filterData, handlers }) => (
        <ReportFiltersUI 
          filterData={filterData} 
          handlers={handlers} 
        />
      )}
    </ReportFiltersLogic>
  );
};

export default ReportFilters;